import React, { useState } from 'react';
import styled from 'styled-components';
import { stringify } from 'query-string';

// Components
import { Modal, LoadingSpinner } from 'wg-fe-ui';
import { handleResponseLanguage } from '../../../../i18n';

interface Props {
  params: unknown;
  taskTitle?: string;
  clickUpIds: {
    en: string;
    nl: string;
    fr: string;
  };
  setShowModal: (p: boolean) => void;
}

const ClickUpReportModal: React.FC<React.PropsWithChildren<Props>> = ({
  params,
  taskTitle,
  clickUpIds,
  setShowModal,
  ...otherProps
}) => {
  const [isLoading, setIsLoading] = useState(true);

  const getClickupUrl = () => {
    let url = `https://forms.clickup.com/f/${handleResponseLanguage(
      clickUpIds,
    )}?${stringify(params as { [key: string]: string }, { sort: false })}`;

    if (url.length > 2000) {
      url = url.substring(0, 1997);
      url += '_CUT';
    }

    return url;
  };

  return (
    <StyledModal
      setShowModal={(show: boolean) => {
        setShowModal(show);
        if (!show) setIsLoading(true);
      }}
      showModal={true}
      canClose
      large
      {...otherProps}
    >
      {isLoading && (
        <LoadingWrapper>
          <LoadingSpinner />
        </LoadingWrapper>
      )}
      <Frame
        data-test-id="Common_ClickUpReportModal_Frame"
        title="report"
        className="clickup-embed clickup-dynamic-height"
        src={getClickupUrl()}
        frameBorder="0"
        onLoad={() => setIsLoading(false)}
      />
      <script
        async
        src="https://app-cdn.clickup.com/assets/js/forms-embed/v1.js"
      ></script>
    </StyledModal>
  );
};

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const Frame = styled.iframe`
  background: transparent;
  width: 100%;
  height: 100%;
`;

const StyledModal = styled(Modal)`
  > div {
    height: 100%;
    padding: 0;
  }
  border: none;
  height: 900px;
  overflow-y: hidden;
`;

export default ClickUpReportModal;
